import { CardHistoryJsonldCardHistoryRead } from '@/api/generated';
import { CARD_BADGE_VARIANT } from '@/atoms/CardBadge';

export const HYSTORY_TYPE_TO_ICON = {
  FUNCTIONAL_ERRATUM: 'fa-solid fa-paintbrush',
  SUSPENDED: 'fa-solid fa-hourglass-half',
  RULING: 'fa-solid fa-question',
  UNSUSPENDED: 'fa-solid fa-hourglass-half',
  BALANCING_ERRATUM: 'fa-solid fa-scale-balanced',
};

export const HYSTORY_TYPE_TO_VARIANT = {
  FUNCTIONAL_ERRATUM: 'SECURITY_BLUE',
  SUSPENDED: 'WARNING',
  RULING: 'SECURITY_GREEN',
  UNSUSPENDED: 'SECURITY_GREEN',
  BALANCING_ERRATUM: 'SECURITY_GREEN',
};

const getBadgePropsFromHistory = (historyType: CardHistoryJsonldCardHistoryRead['type']) => {
  return {
    icon: historyType ? HYSTORY_TYPE_TO_ICON[historyType] : undefined,
    variant: historyType ? (HYSTORY_TYPE_TO_VARIANT[historyType] as keyof typeof CARD_BADGE_VARIANT) : undefined,
  };
};

export default getBadgePropsFromHistory;
